import { createTheme, responsiveFontSizes } from '@mui/material/styles';

const MAROON = '#7B2D26';
const GOLD = '#C8922A';
const CREAM = '#FFFAF5';

let baseTheme = createTheme({
  breakpoints: {
    values: { xs: 0, sm: 600, md: 900, lg: 1200, xl: 1536 },
  },
  palette: {
    mode: 'light',
    primary: {
      main: MAROON,
      light: '#A0453D',
      dark: '#5C1F1A',
    },
    secondary: {
      main: GOLD,
      light: '#DEAB4A',
      dark: '#9E7220',
    },
    background: {
      default: CREAM,
      paper: '#FFFFFF',
    },
    text: {
      primary: '#2D2D2D',
      secondary: '#5A5A5A',
    },
    success: { main: '#2E7D32' },
    warning: { main: '#ED6C02' },
    error: { main: '#D32F2F' },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: 'clamp(1.8rem, 4vw, 2.8rem)',
      fontWeight: 700,
      color: MAROON,
    },
    h2: {
      fontSize: 'clamp(1.5rem, 3vw, 2.2rem)',
      fontWeight: 600,
      color: '#2D2D2D',
    },
    h3: {
      fontSize: 'clamp(1.3rem, 2.4vw, 1.75rem)',
      fontWeight: 600,
      color: '#2D2D2D',
    },
    h4: {
      fontSize: 'clamp(1.1rem, 2vw, 1.4rem)',
      fontWeight: 600,
      color: '#2D2D2D',
    },
    h5: {
      fontSize: '1.1rem',
      fontWeight: 500,
      color: '#3D3D3D',
    },
    h6: {
      fontSize: '1rem',
      fontWeight: 500,
      color: '#5A5A5A',
    },
    body1: {
      fontSize: '0.95rem',
      color: '#5A5A5A',
      lineHeight: 1.7,
    },
    body2: {
      fontSize: '0.85rem',
      color: '#757575',
      lineHeight: 1.6,
    },
  },
  shape: {
    borderRadius: 10,
  },
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          background: '#FFFFFF',
          border: '1px solid #F0E6DA',
          borderRadius: 10,
          boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 10,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none',
          fontWeight: 600,
          padding: '8px 20px',
        },
        contained: {
          backgroundColor: MAROON,
          color: '#FFFFFF',
          boxShadow: '0 2px 6px rgba(123,45,38,0.25)',
          '&:hover': {
            backgroundColor: '#5C1F1A',
            boxShadow: '0 4px 12px rgba(123,45,38,0.35)',
          },
        },
        outlined: {
          borderColor: MAROON,
          color: MAROON,
          '&:hover': {
            backgroundColor: 'rgba(123,45,38,0.06)',
            borderColor: '#5C1F1A',
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 8,
            '& fieldset': { borderColor: '#D4C5B5' },
            '&:hover fieldset': { borderColor: GOLD },
            '&.Mui-focused fieldset': { borderColor: MAROON },
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 6,
          fontWeight: 500,
        },
        colorPrimary: {
          backgroundColor: MAROON,
          color: '#FFFFFF',
        },
        colorSecondary: {
          backgroundColor: GOLD,
          color: '#FFFFFF',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#FFFFFF',
          color: '#2D2D2D',
          boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
  },
});

export const glassmorphismTheme = responsiveFontSizes(baseTheme);
